<div class="container">
  <div class="card flex-auto">
    <div class="px-6 py-4 border-b flex items-center header-title">
      <h2 class="title m-0">{{"TROPHIES_LIST.NEW_TROPHY" | translate}}</h2>
      <div class="flex-end">
        <button [matMenuTriggerFor]="languageFormMenu" mat-icon-button type="button" align="end">
          <mat-icon svgIcon="{{iconFormFlag}}"></mat-icon>
        </button>
        <mat-menu #languageFormMenu="matMenu" overlapTrigger="false">
          <button mat-menu-item (click)="changeFormLanguage('it')">
            <mat-icon svgIcon="flag:italy"></mat-icon>
            <span>Italiano</span>
          </button>
          <button mat-menu-item (click)="changeFormLanguage('en')">
            <mat-icon svgIcon="flag:united-states"></mat-icon>
            <span>English</span>
          </button>
        </mat-menu>
      </div>
    </div>

    <div class="px-6 py-4 flex flex-col">

      <div class="card px-6 py-4 flex flex-col subCards" >
        <div class="flex flex-col sm:flex-row sm:gap-4">
          <mat-form-field class="flex-auto" *ngIf="formLang=='it'">
            <mat-label>{{"TROPHIES_LIST.TITLE" | translate}} {{"GLOBAL.ITA" | translate}}</mat-label>
            <input matInput [(ngModel)]="ngForm.i18nTitle['IT']" required>
          </mat-form-field>

          <mat-form-field class="flex-auto" *ngIf="formLang=='en'">
            <mat-label>{{"TROPHIES_LIST.TITLE" | translate}} {{"GLOBAL.ENG" | translate}}</mat-label>
            <input matInput [(ngModel)]="ngForm.i18nTitle['EN']" required>
          </mat-form-field>

          <div class="d-flex-draft">
            <mat-label>{{"TROPHIES_LIST.DRAFT" | translate}}</mat-label>
            <mat-slide-toggle [(ngModel)]="ngForm.draft"></mat-slide-toggle>
          </div>
        </div>
        <div class="flex flex-col sm:flex-row sm:gap-4">
          <mat-form-field class="flex-auto">
            <mat-label>{{"TROPHIES_LIST.TYPE" | translate}}</mat-label>
            <mat-select matInput [(ngModel)]="ngForm.type" required>
              <mat-option [value]="option.key" *ngFor="let option of types">{{ option.description }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="flex-auto" *ngIf="ngForm.type === 'workout'">
            <mat-label>{{"TROPHIES_LIST.WORKOUT-AMOUNT" | translate}}</mat-label>
            <input matInput type="number" [(ngModel)]="ngForm.workoutAmount" required>
          </mat-form-field>
          <mat-form-field class="flex-auto" *ngIf="ngForm.type === 'consistency'">
            <mat-label>{{"TROPHIES_LIST.CONSISTENCY-AMOUNT" | translate}}</mat-label>
            <input matInput type="number" [(ngModel)]="ngForm.consistencyMonths" required>
          </mat-form-field>
          <mat-form-field class="flex-auto" *ngIf="ngForm.type === 'challenges'">
            <mat-label>{{"TROPHIES_LIST.CHALLENGE-ID" | translate}}</mat-label>
            <mat-select matInput [(ngModel)]="ngForm.challengeId" required>
              <mat-option [value]="option._id" *ngFor="let option of challenges">{{ option.i18nTitle[translate.currentLang.toUpperCase()] }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="flex-auto" *ngIf="ngForm.type === 'fullWeeks'">
            <mat-label>{{"TROPHIES_LIST.WEEK-NUMBER" | translate}}</mat-label>
            <input matInput type="number" [(ngModel)]="ngForm.programWeekNumber" required>
          </mat-form-field>
        </div>
        <div class="flex flex-col sm:flex-row sm:gap-4" *ngIf="ngForm.type === 'programs'">
          <mat-form-field class="flex-auto">
            <mat-label>{{"TROPHIES_LIST.PROGRAM-ID" | translate}}</mat-label>
            <mat-select matInput [(ngModel)]="ngForm.programId" required>
              <mat-option [value]="option.id" *ngFor="let option of programs">{{ option.name }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="flex-auto">
            <mat-label>{{"TROPHIES_LIST.WORKOUT-AMOUNT" | translate}}</mat-label>
            <input matInput type="number" [(ngModel)]="ngForm.programWorkoutNumber" required>
          </mat-form-field>
          <mat-form-field class="flex-auto">
            <mat-label>{{"TROPHIES_LIST.WEEK-NUMBER" | translate}}</mat-label>
            <input matInput type="number" [(ngModel)]="ngForm.programWeekNumber" required>
          </mat-form-field>
        </div>

      <div class="flex flex-col sm:flex-row sm:gap-4" *ngIf="ngForm.type === 'workoutInWeeks'">
          <mat-form-field class="flex-auto">
            <mat-label>{{"TROPHIES_LIST.WORKOUT-AMOUNT" | translate}}</mat-label>
            <input matInput type="number" [(ngModel)]="ngForm.programWorkoutNumber" required>
          </mat-form-field>
          <mat-form-field class="flex-auto">
            <mat-label>{{"TROPHIES_LIST.WEEK-NUMBER" | translate}}</mat-label>
            <input matInput type="number" [(ngModel)]="ngForm.programWeekNumber" required>
          </mat-form-field>
        </div>

        <mat-form-field class="flex-auto" *ngIf="formLang=='it'">
          <mat-label>{{"TROPHIES_LIST.DESCRIPTION" | translate}} {{"GLOBAL.ITA" | translate}}</mat-label>
          <textarea matInput [(ngModel)]="ngForm.i18nDescription['IT']" required></textarea>
        </mat-form-field>

        <mat-form-field class="flex-auto" *ngIf="formLang=='en'">
          <mat-label>{{"TROPHIES_LIST.DESCRIPTION" | translate}} {{"GLOBAL.ENG" | translate}}</mat-label>
          <textarea matInput [(ngModel)]="ngForm.i18nDescription['EN']" required></textarea>
        </mat-form-field>
      </div>

      <div class="bottoni">
        <button (click)="confirmClose()" class="m-4">{{"GLOBAL.CLOSE" | translate}}</button>
        <button mat-raised-button (click)="submit()" [disabled]="isFormInvalid()" class="m-4 bottone-viola">{{"GLOBAL.CREATE" |
          translate}}</button>
      </div>
    </div>
  </div>
</div>
